/**
 * Created by Owner on 2016/10/24.
 */
import {Component} from '@angular/core';
import {LotteryMathZXFSComponent} from "./zxfs";
import {LotteryMath} from "./lotteryMath";
import {MathUtil} from "../../util/mathUtil";

@Component({
  selector: 'lottery-math-rzx',
  templateUrl: 'selectMath.html',
})
export class LotteryMathRZXComponent extends LotteryMathZXFSComponent implements LotteryMath {
  max_place: number = 0;

  ngOnInit() {
    this.selectAreaOption["layout"].forEach(item=> {
      if (item.place > this.max_place) {
        this.max_place = item.place;
      }
    });
  }

  changeTotal() {
    let mname = this.selectAreaOption["mname"];
    let tmpTotal: number = 0;
    let data_sel = this.children.toArray();
    let aCodePosition: any = [];
    for (let i = 0; i <= this.max_place; i++) {
      var codelen = data_sel[i]["selectNo"].length;
      if (codelen > 0) {
        aCodePosition.push(i)
      }
    }
    var sellen = mname.substring(mname.length - 1);
    var aPositionCombo = MathUtil.getCombination(aCodePosition, sellen);
    var iComboLen = aPositionCombo.length;
    var aCombo = [];
    var iLen = 0;
    var tmpNums = 1;
    for (let j = 0; j < iComboLen; j++) {
      aCombo = aPositionCombo[j].split(",");
      iLen = aCombo.length;
      tmpNums = 1;
      for (let h = 0; h < iLen; h++) {
        tmpNums *= data_sel[aCombo[h]]["selectNo"].length;
      }
      tmpTotal += tmpNums
    }
    this.setTotal(tmpTotal);
  }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/rzx.ts